import {Injectable} from '@angular/core';
import {Disposable} from '../../shared/extensions/disposable';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {ActionType} from '../action-type';
import {ProgressService} from './progress.service';

@Injectable({
    providedIn: 'root',
})
export class CaseHeaderService extends Disposable {

    private actionSubject = new Subject<ActionType>();
    private canSaveSubject = new BehaviorSubject<boolean>(true);
    private canSubmitSubject = new BehaviorSubject<boolean>(false);
    private showSubmitSubject = new BehaviorSubject<boolean>(false);

    public isLoading$: Observable<boolean>;

    constructor(private progress: ProgressService) {
        super();
        this.isLoading$ = progress.isLoading$;
    }

    get action$(): Subject<ActionType> {
        return this.actionSubject;
    }

    get canSave$(): Observable<boolean> {
        return this.canSaveSubject.asObservable();
    }

    get canSubmit$(): Observable<boolean> {
        return this.canSubmitSubject.asObservable();
    }

    get showSubmit$(): Observable<boolean> {
        return this.showSubmitSubject.asObservable();
    }

    public handleSave(): void {
        this.actionSubject.next(ActionType.Save);
    }

    public handleSubmit(): void {
        this.actionSubject.next(ActionType.Submit);
    }

    public setCanSave(canSave: boolean): void {
        this.canSaveSubject.next(canSave || false);
    }

    public setCanSubmit(canSubmit: boolean): void {
        this.canSubmitSubject.next(canSubmit || false);
    }

    public setShowSubmit(showSubmit: boolean): void {
        this.showSubmitSubject.next(showSubmit || false);
    }

}
